export const LOCALES = {
  ENGLISH: "en",
};
